import { render, staticRenderFns } from "./HostingPlans.vue?vue&type=template&id=3b248dc8&"
import script from "./HostingPlans.vue?vue&type=script&lang=js&"
export * from "./HostingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports